import ManagementSystem from 'containers/ManagementSystem';
import Summary from 'containers/Summary';
import Translation from 'containers/Translation';
import Upload from 'containers/Upload';
import ChangePasswordForm from 'containers/User/ChangePasswordForm';

import Ask from './containers/Ask';
import Document from './containers/Document';
import { DocumentList, ProjectList, Synchronization } from './containers/Synchronization';
import SyncSharepoint from './containers/SyncSharepoint';

export interface IRoute {
  key: string;
  path: string;
  exact: boolean;
  label?: string;
  isMobileAllow?: boolean;
  isShowAllow?: boolean;
  container: () => JSX.Element;
}

export const privateRouters: IRoute[] = [
  {
    key: 'translation',
    path: '/translation',
    exact: true,
    label: 'route.translator',
    isMobileAllow: true,
    isShowAllow: true,
    container: Translation,
  },
  {
    key: 'summary',
    path: '/summary',
    exact: true,
    label: 'route.summary',
    isMobileAllow: true,
    isShowAllow: true,
    container: Summary,
  },
  {
    key: 'chat',
    path: '/',
    exact: true,
    label: 'route.chat',
    isMobileAllow: true,
    isShowAllow: true,
    container: Ask,
  },
  {
    key: 'document',
    path: '/document',
    exact: true,
    label: 'route.document',
    isMobileAllow: true,
    isShowAllow: true,
    container: Document,
  },
];

export const privateUserRouters: IRoute[] = [
  {
    key: 'translation',
    path: '/translation',
    exact: true,
    label: 'route.translator',
    isMobileAllow: true,
    isShowAllow: true,
    container: Translation,
  },
  {
    key: 'summary',
    path: '/summary',
    exact: true,
    label: 'route.summary',
    isMobileAllow: true,
    isShowAllow: true,
    container: Summary,
  },
  {
    key: 'chat',
    path: '/',
    exact: true,
    label: 'route.chat',
    isMobileAllow: true,
    isShowAllow: true,
    container: Ask,
  },
  {
    key: 'document',
    path: '/document',
    exact: true,
    label: 'route.document',
    isMobileAllow: true,
    container: Document,
  },
  {
    key: 'upload',
    path: '/upload',
    exact: true,
    label: 'route.upload',
    isMobileAllow: false,
    isShowAllow: true,
    container: Upload,
  },
];

export const userRouters: IRoute[] = [
  {
    key: 'change-password',
    path: '/change-password',
    container: ChangePasswordForm,
    exact: false,
    isMobileAllow: true,
    isShowAllow: true,
  },
  {
    key: 'upload',
    path: '/upload',
    exact: true,
    label: 'route.upload',
    isMobileAllow: false,
    isShowAllow: true,
    container: Upload,
  },
];

export const adminRouters: IRoute[] = [
  {
    key: 'sync',
    path: '/sync-sharepoint',
    exact: true,
    label: 'Connection',
    isMobileAllow: false,
    isShowAllow: true,
    container: SyncSharepoint,
  },
  {
    key: 'synchronization',
    path: '/synchronization',
    exact: true,
    label: 'Synchronization',
    isMobileAllow: false,
    isShowAllow: true,
    container: Synchronization,
  },
  {
    key: 'sync-projects',
    path: '/sync-projects',
    exact: true,
    label: 'Sync Projects',
    isMobileAllow: false,
    isShowAllow: false,
    container: ProjectList,
  },
  {
    key: 'sync-documents',
    path: '/sync-documents',
    exact: true,
    label: 'Sync Documents',
    isMobileAllow: false,
    isShowAllow: false,
    container: DocumentList,
  },
  {
    key: 'change-password',
    path: '/change-password',
    container: ChangePasswordForm,
    label: 'Change password',
    isMobileAllow: true,
    isShowAllow: true,
    exact: false,
  },
  {
    key: 'upload',
    path: '/upload',
    exact: true,
    label: 'route.upload',
    isMobileAllow: false,
    container: Upload,
  },
];

export const superAdminRouters: IRoute[] = [
  {
    key: 'management-system',
    path: '/management-system',
    exact: true,
    label: 'route.managementSystem',
    isMobileAllow: true,
    container: ManagementSystem,
  },
];
